module.exports = {"id":"180216","name":"Séamus Coleman","rating":"81","photo":"./data/images/photos/2/180216.png","club":{"name":"Everton","logo":"./data/images/clubs/Everton.png"},"positions":["DD","DLD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SeamusColeman0.json
// module id = 3847
// module chunks = 0